import { render, staticRenderFns } from "./VetUpload.vue?vue&type=template&id=e18ce846&"
import script from "./VetUpload.vue?vue&type=script&lang=js&"
export * from "./VetUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports